module.exports = __webpack_public_path__ + "img/finance.e034c6c8.png";